const TokenStorageService = (() => {
    function setAccessToken(token: string): void {
        localStorage.setItem('access_token', token)
    }

    function getAccessToken(): string | null {
        return localStorage.getItem('access_token')
    }

    function clearToken(): void {
        localStorage.removeItem('access_token')
    }

    return {
        setAccessToken,
        getAccessToken,
        clearToken,
    }
})()

export default TokenStorageService
